// src/utils/formatters.ts

/**
 * Format a number with commas for better readability
 * @param value - The number to format
 * @returns Formatted string with commas
 */
export const formatNumber = (value: number | string | undefined | null): string => {
  if (value === null || value === undefined || value === "") {
    return "0";
  }
  
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  
  if (isNaN(numValue)) {
    return "0";
  }
  
  return numValue.toLocaleString("en-US");
};

/**
 * Format a currency value with commas and dollar sign
 * @param value - The number to format
 * @returns Formatted currency string
 */
export const formatCurrency = (value: number | string | undefined | null): string => {
  if (value === null || value === undefined || value === "") {
    return "$0";
  }
  
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  
  if (isNaN(numValue)) {
    return "$0";
  }
  
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(numValue);
};
